/**
 * Created by olga on 26.10.2022
 */

const FeedableHintContent = function (options) {
    this.food = options.food;
    this.unit = options.unit;

    this.doNotBlock = {
        x: this.unit.x,
        y: this.unit.y
    };
};

FeedableHintContent.isApplicable = function (options) {
    return options.food && options.food.code !== undefined;
};

FeedableHintContent.prototype.hasSameContent = function (options) {
    return this.food.code === options.code && Unit.Equals(this.unit, options.unit);
};

FeedableHintContent.prototype.getMessages = function () {
    return [
        { text: Messages.get("Feedable.hint1") },
        { icon: UnitView.getUnitImage(this.food, { preferStatic: true }) },
        { text: Messages.get("Feedable.hint2") }
    ];
};